const requireModule = require.context('.', true, /\.vue$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName.endsWith('index.js')) return
  const moduleName = fileName.replace(/(\.\/|\.vue)/g, '')
  modules[moduleName] = requireModule(fileName).default
})

modules['analytics-navigate-bid'] = modules['analytics-navigate']
modules['analytics-navigate-shop'] = modules['analytics-navigate']

modules['analytics-favorite-residential'] = modules['analytics-residential-action']
modules['analytics-floorplan-residential'] = modules['analytics-residential-action']

modules['milestone-purchase-residential'] = modules['milestone']
modules['milestone-unpurchase-residential'] = modules['milestone']

export default modules
